import React from 'react';
import MapSection from './MapSection';
import BannerSection from './BannerSection';
import ContactUsFormSection from './ContactUsFormSection';

const ContactPage: React.FC = () => {
  return (
<article id="post-1453" className ="post_item_single post_type_page post-1453 page type-page status-publish hentry">

	
<div className="post_content entry-content">
      <div data-elementor-type="wp-page" data-elementor-id="1453" className="elementor elementor-1453">
          
          <ContactUsFormSection />
          <BannerSection />
          <MapSection />
        </div>
      </div>
    </article>
  );
};

export default ContactPage;
